<template>
  <div>
    <van-nav-bar title="确认订单" left-text="返回" left-arrow @click-left="onClickLeft" />
    <div v-if="!islogin" style="padding-top:300px;">
      <p>您还没有登录哦，请先登录</p>
      <van-button round @click="ShowLogin" type="info">点击登录</van-button>
    </div>
    <div v-else>
      <!-- 默认收货地址 -->
      <van-cell
      class="address-item margin-top"
      size="large"
      icon="location-o"
      is-link
      @click="onSelect">
      <div v-if="address && address.ID > 0" class="has-address">
        <div class="address-name">{{address.ContractName}}, {{address.ContractTel}}</div>
        <div class="address-vice">
          {{address.RegionFullDesc}} {{address.DetailAddr}}
        </div>
      </div>
      <div v-else class="no-address">请选择地址</div>
    </van-cell>
    <div style="height:617px;">
      <!-- 商品详情 -->
      <van-card v-for="(item,idx) in orderlist" :key="idx" 
          :num="item.Num" 
          :price="item.UnitPrice"
          :desc="item.Specs"
          :title="item.GoodsName"
          :thumb="item.GoodsImg">
      </van-card>
      <!-- 提交订单 -->
      <van-submit-bar :price="totalPrice" 
      tip-icon="info-o"
      :loading="submitloading" :disabled="totalPrice<=0" button-text="提交订单"
        @submit="onSubmit" >
      </van-submit-bar>
    </div>
    </div>
    
  </div>
</template>

<script>
import { SubmitBar ,Button,Card,Popup, NavBar, CellGroup, Field, Cell, Dialog} from "vant";
import { debug } from 'util';
export default {
  name: "",
  data() {
    return {
      submitloading: false,
      totalPrice: 0,
      cartNum: 0,
      datalist: [],
      orderlist: [],
      address: "",
      skuid: 0,
      addrsid: 0,
      from: 'quick',
      confirmStr: {},
      spec_id: 0
    };
  },
  computed: {
    islogin() {
      return this.$store.state.isLogin;
    },
  },
  methods: {
    /*提交订单 */
    onSubmit() {
      if (!this.address || !this.address.ID) {
        this.$toast.fail("请选择收货地址");
        return;
      }
      Dialog.confirm({
        title: '确认下单',
        message: '确认下单支付?',
      })
      .then(() => {
        this.doSubmit();
      })
    },
    doSubmit() {
      this.$toast.loading();
      this.confirmStr={
          products: this.from=='cart'?this.skuid2Obj(this.skuid):[{ sku_id: this.skuid, count: this.cartNum, spec_id: this.spec_id }],
          addressId: this.address.ID,
          from: this.from,
          totalPrice: this.totalPrice/100
      };
      this.$http
      .post("Order/AddConfirm",this.confirmStr)
        .then(res => {
          if(res.data=="success"){
            this.$toast("下单成功~");
            this.$router.push({
              name: "OrderList",
              params: { status: 0 },
            });
          }else{
            this.$toast.fail(res.data);
          }
        })
        .catch(err => {
          this.$toast.fail(err.msg || "下单失败");
        });
    },
    ShowLogin() {
      this.$store.commit("showLogin");
    },
    /*初始化加载选择商品明细 */
    GetData() {
      if (this.islogin) {
        var cartNum = 0;
        var that = this;
        that.$http.get("Order/GetOrderDetail").then((res) => {
          that.$toast.clear();
          that.datalist = res.data.Data;
          that.totalPrice=0;
          that.datalist.forEach((item, idx, array) => {
            if(that.skuid.indexOf(item.ID) !== -1){
              that.orderlist.push(item);
              cartNum += item.Num;
              that.totalPrice+=item.RowPrice*100;            
              array[idx].GoodsImg =
                that.$file.url +
                "Images/Mall/GoodsImg/" +
                item.GoodsCode +
                "/" +
                item.GoodsImg.split(",")[0];
            }
            
          });
          that.$store.commit("setCartCount", cartNum);
        });
      }
    },
    /*查询默认收货地址 */
    GetAddr(){
      var that = this;
      var addrId = that.addrsid;
      if(addrId==0||addrId==undefined){
        that.$http.get("ReciveAddrs/GetDefaultAddr").then((res) => {
          that.address = res.data.Data;
        });
      }else{
        that.$http.get("ReciveAddrs/GetAddrById?id="+addrId).then((res) => {
          that.address = res.data.Data;
        });
      }
    },
    /*选择收货地址 */
    onSelect(){
      if(this.from=="cart"){
        this.$router.push({
        name: "ReciveAddrs",
        params: {skuid: this.skuid, from: this.from},
        });
      }else{
        this.$router.push({
        name: "ReciveAddrs",
        params: {
          sku_id: this.spec_id,
          product_id: this.skuid, 
          count: this.cartNum,  
          from: this.from
          },
        });
      }
      // this.$router.push({
      //   name: "ReciveAddrs",
      //   params: {skuid: this.skuid, from: this.from},
      // });
    },
    /*返回 */
    onClickLeft() {
      this.$router.back(-1);
    },
    skuid2Obj(ids){
      let idArr=ids.toString().split(',')
      return idArr.map(value=>{
        return {
          sku_id:parseInt(value)
        }
      })
    },
    GetBuyData() {//直接购买
      if (this.islogin) {
        var that = this;
        that.$http.get("Goods/GoodsConfirm?product_id="+that.skuid+"&sku_id="+that.spec_id+"&count="+that.cartNum).then((res) => {
          that.orderlist = res.data.Data;
          that.totalPrice=0;
          that.orderlist.forEach((item, idx, array) => {
            that.totalPrice+=item.RowPrice*100;            
              array[idx].GoodsImg =
                that.$file.url +
                "Images/Mall/GoodsImg/" +
                item.GoodsCode +
                "/" +
                item.GoodsImg.split(",")[0];
          });
        });
      }
    },
  },
  created() {
    // this.skuid = this.$route.params.skuid;
    this.addrsid = this.$route.params.addrsid;//默认收货id
    var froms = this.$route.params.from;      //来源，购物车or商品明细
    if(froms!=null&&froms!=undefined){
        this.from = froms;
    }
    
    this.spec_id = this.$route.params.sku_id;//规格id
    
    if(this.from=="cart"){//购物车
      this.skuid = this.$route.params.skuid;
      this.GetData();
    }else{               //商品明细
      this.skuid = this.$route.params.product_id;
      this.cartNum = this.$route.params.count;
      this.GetBuyData();
    }

    this.GetAddr();//加载收货地址
    
  },
  components: {
    [SubmitBar.name]: SubmitBar,
    [Button.name]: Button,
    [Card.name]: Card,
    [Popup.name]: Popup,
    [NavBar.name]: NavBar,
    [CellGroup.name]: CellGroup, 
    [Field.name]: Field,
    [Cell.name]: Cell,
    [Dialog.name]: Dialog,
  },
};
</script>

<style>
.van-submit-bar {
  bottom: 51px;
}
.van-card__title {
  max-width: 175px;
  text-align: left;
  padding-left: 15px;
}
.van-card__bottom {
  text-align: left;
  padding-left: 15px;
}
.van-card__content{
      justify-content: space-around;
}
.van-card{
  margin-right: 10px;
    padding: 11px;
    background-color: #fff;
    border-radius: 8px;
    
    margin-left: 10px;
    margin-top: 10px;
}
.van-submit-bar__tip{
      text-align: left;
}
.empty-box{
  text-align: center;
  padding-top:40px;
  padding-bottom:40px;
  color:#999;
}
.van-button{
    margin-top:10px;
  }

  .has-address {
      padding: 5px;
    }
    .no-address {
      line-height: 3em;
      color: #999;
    }
  .van-card {
    background: #fff;
  }

</style>